enum SupplementType {
    Amount = 1,
    Percentage = 2,
    Calculated = 3,
}

export default SupplementType;
